module.exports = __webpack_public_path__ + "media/images/pen_orangered-51cd2f4f.png";